/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Legaroo_NameInputs */

const en_service_legaroo_name = /** @type {(inputs: Service_Legaroo_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legaroo`)
};

const fr_service_legaroo_name = /** @type {(inputs: Service_Legaroo_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legaroo`)
};

/**
* | output |
* | --- |
* | "Legaroo" |
*
* @param {Service_Legaroo_NameInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_legaroo_name = /** @type {((inputs?: Service_Legaroo_NameInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Legaroo_NameInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_legaroo_name(inputs)
	return fr_service_legaroo_name(inputs)
});